import React, { useEffect, useState } from 'react';
import { Col, Row, Card } from 'antd';
import { FaExchangeAlt, FaChevronRight } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import { getFlightInternationalList } from '../../../services/flight/flightServices';
import moment from 'moment';

const PopularFlightInternational = () => {

    const navigate = useNavigate();
    const [internationalData, setInternationalData] = useState(null);
    const [error, setError] = useState(null);
    const fetchinternationalData = async () => {
        try {
            const data = await getFlightInternationalList();
            setInternationalData(data?.data);
        } catch (err) {
            setError('Failed to fetch domestic flights');
        }
    };


    useEffect(() => {
        fetchinternationalData();
    }, []);


    const formattedTomorrow = moment().add(1, 'days').format('DD/MMM/YYYY');

    const handleFlightClick = (flight) => {
        sessionStorage.setItem('selectFromCity', JSON.stringify(flight?.from_city));
        sessionStorage.setItem('selectFromCityName', JSON.stringify(flight?.from_city_airport));
        sessionStorage.setItem('selectTOCity', JSON.stringify(flight?.to_city));
        sessionStorage.setItem('selectTOCityName', JSON.stringify(flight?.to_city_airport));
        sessionStorage.setItem('seatTypeflight', JSON.stringify("ECONOMY"));
        sessionStorage.setItem('returnFlight', JSON.stringify('oneWay'));
        sessionStorage.setItem('DepartureFlight', JSON.stringify(formattedTomorrow));
        sessionStorage.setItem('selectAdultsflight', JSON.stringify(1));
        sessionStorage.setItem('selectChildflight', JSON.stringify(0));
        sessionStorage.setItem('selectInfantsflight', JSON.stringify(0));
        const formattedFromCity = flight?.from_city?.toLowerCase().replace(/\s+/g, '-');
        const formattedToCity = flight?.to_city?.toLowerCase().replace(/\s+/g, '-');
        const urlIdDynamic = `${formattedFromCity}-to-${formattedToCity}-flights`;
        navigate(`/flights/${urlIdDynamic}`);
    };

    return (
        <>
            {internationalData && internationalData?.length > 0 && (
                <section className="flight-area mb-5">
                    <div className="container">
                        <Row gutter={16}>
                            <Col xs={24}>
                                <Card>
                                    <div className="section-title mb-3">
                                        <div>
                                            <h3>Popular International Destinations </h3>
                                            <span className="top-title">Search Flights & Places Hire to our most popular destinations</span>
                                        </div>
                                        <Link to="/popular-international-destinations" aria-label="See More Flights">See more destinations</Link>
                                    </div>

                                    <Row gutter={20}>
                                        {internationalData?.slice(0, 9).map((flight) => (
                                            <Col key={flight.id} lg={8} md={12} className={flight.id === 3 ? "d-none d-lg-block w-100" : "w-100"}>
                                                {/* <Link to={`/flights/${flight.id}`} className='w-100' aria-label="Domestic Flights"> */}
                                                <div className="card flight-box" onClick={() => handleFlightClick(flight)}>
                                                    <div className="card-body">
                                                        <div className="deal-title d-flex align-items-center justify-content-between">
                                                            <div className="d-flex align-items-center gap-1">
                                                                {/* <span className={`img-collection pairline ${flight.imageClass}`}></span> */}
                                                                <h3 className="deal__title py-2">
                                                                    <span className="d-flex align-items-center" style={{ fontWeight: '600' }}>
                                                                        {flight?.from_city}<FaExchangeAlt className="mx-2" />{flight?.to_city}
                                                                    </span>
                                                                    {/* <p className="deal__meta">{formattedTomorrow}</p> */}
                                                                </h3>
                                                            </div>
                                                            <FaChevronRight className='fs-6 m-0' />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* </Link> */}
                                            </Col>
                                        ))}
                                    </Row>
                                    {/* <Link className='bottom-btn' to="/popular-domestic-flight" aria-label="See More">See more</Link> */}
                                </Card>
                            </Col>
                        </Row>
                    </div>

                </section>
            )}
        </>
    );
}

export default PopularFlightInternational
